import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the page itself lives in es.industrias.pharma-biotech.landing-in-europe.index.tsx. Without this wrapper the
// page component would shadow every nested child route.
export const Route = createFileRoute("/es/industrias/pharma-biotech/landing-in-europe")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
